import Vue from 'vue'
import router from '@/router/index'
import store from '@/store'
import i18n from '@/plugins/i18n'
import VueAnalytics from 'vue-analytics'

import '@/plugins/vee-validate'
import '@/plugins/vue-js-modal'
import '@/plugins/vuejs-paginate'
import '@/plugins/vue-tags-input'
import '@/plugins/vue-moment'
import '@/plugins/vue-casl'
import '@/plugins/vue-toasted'
import '@/plugins/vue-datatable'
import '@/plugins/vue-tooltip'

import '@/mixins/authorization'

import App from '@/App.vue'
// import Loading from '@/components/Loading'
import Message from '@/components/Message'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Vue.prototype.$appName = process.env.VUE_APP_NAME

// Vue.component('Loading', Loading)
Vue.component('Message', Message)
Vue.config.productionTip = false

// Configuration VueAnalytics
if (process.env.VUE_APP_GA) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA,
    router
  })
}
// Configuration Sentry
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

store.dispatch('appInit').then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
